import { Component, Input } from '@angular/core';
import { AppState } from 'src/app/app.state';

interface CompanyFooter {
  data: any;
  uniqueMlsList: any;
}
@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss'],
})
export class DefaultComponent implements CompanyFooter {
  constructor(public appState: AppState) {}
  @Input() data;
  @Input() uniqueMlsList;
  @Input() currentYear;

  ngOnInit(): void {
  }
}
